export class ConfirmDialogInput {
    headline = '';
    text = '';
    isWarning = false;

    okButton = 'OK';
    buttonColor = 'accent';

    showOkButton2 = false;
    okButton2 = 'OK2';
    buttonColor2 = 'accent';

    cancelButton = 'Abbrechen';
    showCancel = true;
}

export class ConfirmDialogResult {
    ok = false; // false = Abbruch
    confirmed = false;
    confirmed2 = false;
}
